import { useEffect, useState } from 'react';
import { FormControl, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { useApi } from '@backstage/core-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { identityApiRef } from '@backstage/core-plugin-api';

export const DivisionField = ({
  onChange,
  rawErrors,
  required,
  formData,
  uiSchema,
}: FieldExtensionComponentProps<any>) => {
  const catalogApi = useApi(catalogApiRef);
  const identityApi = useApi(identityApiRef);
  
  const label: string = String(uiSchema['ui:options']?.label || 'Division');
  const type: string = String(uiSchema['ui:options']?.type || null);

  const [divisions, setDivisions] = useState<any[]>([]);
  const [divisionRef, setDivisionRef] = useState('');

  // -----------------------------------------------------------------------------------
  // ✔️ 1. Sincronizar con formData
  // -----------------------------------------------------------------------------------
  useEffect(() => {
    if (!formData) return;
    setDivisionRef(formData || '');
  }, [formData]);

  // -----------------------------------------------------------------------------------
  // ✔️ 2. Cargar proyectos donde el usuario es JP
  // -----------------------------------------------------------------------------------
  useEffect(() => {
    const fetchDivisions = async () => {
      const divisionFilter: any = type
        ? { kind: 'Division', 'spec.type': type }
        : { kind: 'Division' };

      const resp = await catalogApi.getEntities({
        filter: divisionFilter,
      });

      setDivisions(resp.items);
    };

    fetchDivisions();
  }, [identityApi, catalogApi]);

  // -----------------------------------------------------------------------------------
  // ✔️ Render
  // -----------------------------------------------------------------------------------
  return (
    <FormControl margin="normal" required={required} fullWidth>
      <Autocomplete
        options={divisions}
        getOptionLabel={opt => opt.metadata.title || ''}
        value={
          divisions.find(
            p => `division:${p.metadata.namespace}/${p.metadata.name}` === divisionRef,
          ) || null
        }
        onChange={(_, newValue) => {
          if (newValue) onChange(`division:${newValue.metadata.namespace}/${newValue.metadata.name}`);
        }}
        renderInput={params => (
          <TextField
            {...params}
            label={label}
            helperText={rawErrors?.[0] || 'Select the division'}
          />
        )}
      />
    </FormControl>
  );
};

// -----------------------------------------------------------------------------------
// ✔️ Registro del Custom Field
// -----------------------------------------------------------------------------------
export const DivisionCaseFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'DivisionField',
    component: DivisionField,
  }),
);
